import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { MapPin } from "lucide-react";

interface LocationPermissionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const LocationPermissionDialog = ({
  open,
  onOpenChange,
  onConfirm,
}: LocationPermissionDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-[90%] sm:max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-primary/10">
            <MapPin className="w-6 h-6 text-primary" />
          </div>
          <AlertDialogTitle className="text-center">
            Permissão de Localização
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center space-y-3 pt-2">
            <p>
              Para rastrear sua corrida com precisão, precisamos acessar sua localização em tempo real.
            </p>
            <div className="text-sm space-y-2 text-left bg-muted/50 p-3 rounded-lg">
              <p className="font-medium text-foreground">O que será usado:</p>
              <ul className="space-y-1 ml-4 list-disc text-muted-foreground">
                <li>Rastreamento GPS durante a corrida</li>
                <li>Cálculo de distância e ritmo</li>
                <li>Geração do mapa do percurso</li>
              </ul>
            </div>
            <p className="text-xs text-muted-foreground">
              Sua localização só é coletada durante corridas ativas e nunca é compartilhada sem seu consentimento.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel>Agora Não</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-primary">
            Permitir Acesso
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
